import { BaseComponentProps } from "../../../../common/types/Data/BaseComponentProps";
import { PagePost } from "../../../../common/Facebook/PagePost";
import React, { CSSProperties, PropsWithChildren } from "react";
import { withContentNavigator, WithContentNavigator } from "../../../hocs/ContentNavigator/withContentNavigator";
import { withAnalytics, WithAnalytics } from "../../../hocs/withAnalytics";
import { ModulePreview } from "../Common/ModulePreview";
import { ModulePreviewHeader } from "../Common/ModulePreviewHeader";
import { ModulePreviewImage } from "../Common/ModulePreviewImage";

export type Props = BaseComponentProps<PagePost> & {};

const buildBackgroundStyle = (pagePost: PagePost): CSSProperties => {
    return {
        backgroundImage: `url(${pagePost.full_picture})`,
        backgroundSize: "cover",
    };
};

//@Todo: refactor some of the base modules into a base base module. A baser module.
const FacebookImageBaseModuleDecorated = (props: PropsWithChildren<Props & WithAnalytics & WithContentNavigator>) => {
    const {
        entity,
        contentNavigator,
        analyticsUtils: { trackClickModuleEvent },
        nested,
    } = props;

    const onClick = () => {
        trackClickModuleEvent(entity);
        contentNavigator.open("facebook:image", { entity }, { nested });
    };

    const style = buildBackgroundStyle(entity.linkedContent);

    return (
        <ModulePreview classNames={["Image"]} onClick={onClick}>
            <ModulePreviewHeader className={"image"} label={entity.shortLabel || entity.label} />
            <ModulePreviewImage entity={entity} file={undefined} style={style} noConditional={true} />
        </ModulePreview>
    );
};

export const FacebookImageBaseModule = withContentNavigator(withAnalytics(FacebookImageBaseModuleDecorated));
